import {
  AUTOMATION_TOUR_STEP_NAME,
  AutomationTourStepName,
} from 'models/MixpanelEvents';

export const CONFIGURE_SELECTOR = 'workflow-configure-selector';

export const FILES_REACH_SELECTOR = 'workflow-files-reach-selector';

export const RULES_SELECTOR = 'workflow-rules-selector';

export const FILES_SELECTOR = 'workflow-files-selector';

const CONFIGURE_STEP = {
  selector: CONFIGURE_SELECTOR,
  title: 'configureLeadStages',
  description: 'configureLeadStagesDescription',
};

const FILES_REACH_STEP = {
  selector: FILES_REACH_SELECTOR,
  title: 'chooseHowLeadsGetFiles',
  description: 'chooseHowLeadsGetFilesDescription',
};

const FILES_STEP = {
  selector: FILES_SELECTOR,
  title: 'pickStageFiles',
  description: 'pickStageFilesDescription',
};

const RULES_STEP = {
  selector: RULES_SELECTOR,
  title: 'decideWhatHappensNext',
  description: 'decideWhatHappensNextDescription',
};

export const GUIDE_STEPS = [
  CONFIGURE_STEP,
  FILES_REACH_STEP,
  FILES_STEP,
  RULES_STEP,
];

// Mobile shows one screen at a time, so each step opens the screen holding its anchor.
export const MOBILE_GUIDE_STEPS = [
  { ...CONFIGURE_STEP, path: '.' },
  { ...FILES_REACH_STEP, path: 'enquire' },
  { ...FILES_STEP, path: 'enquire?tab=files' },
  { ...RULES_STEP, path: 'enquire?tab=completion' },
];

// Without Data Room access the files steps have nothing to point at.
export const getGuideSteps = (
  isAbovePhablet: boolean,
  canAccessDataRoom: boolean,
) => {
  const steps = isAbovePhablet ? GUIDE_STEPS : MOBILE_GUIDE_STEPS;

  if (canAccessDataRoom) return steps;

  return steps.filter(
    ({ selector }) =>
      selector !== FILES_REACH_SELECTOR && selector !== FILES_SELECTOR,
  );
};

export const GUIDE_STEP_NAMES: Record<string, AutomationTourStepName> = {
  [CONFIGURE_SELECTOR]: AUTOMATION_TOUR_STEP_NAME.LEAD_STAGES,
  [FILES_REACH_SELECTOR]: AUTOMATION_TOUR_STEP_NAME.FILES_LEADS_REACH,
  [FILES_SELECTOR]: AUTOMATION_TOUR_STEP_NAME.FILES,
  [RULES_SELECTOR]: AUTOMATION_TOUR_STEP_NAME.STAGE_RULES,
};
